import type { AssetTypeTemplateLinkProps } from "./asset-type-template-link.type";

import { Spin } from "antd";

import { useGetAssetTypeTemplate } from "@/modules/asset-type/asset-type-template";
import { ModelLink } from "@/modules/model-link";

const AssetTypeTemplateLink = ({
  assetType,
  fallback,
  ...linkProps
}: AssetTypeTemplateLinkProps) => {
  const { template, isLoading } = useGetAssetTypeTemplate(assetType);

  if (isLoading) return <Spin />;

  if (!template) return fallback ?? null;

  return <ModelLink {...linkProps} model="technicalform" item={template} />;
};

export default AssetTypeTemplateLink;
